/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { PacingViewApiResponse } from '../endpoints/pacing.types';
import ViewSelector from '../components/view-selector';
import ViewManager from '../components/view-manager';
import CreateViewButton from '../components/create-view-button';
// import PacingGanttView from '../components/pacing-gantt-view';
import SearchInput from '../../../components/search-input/search-input';
import VisibilityToggle from 'src/components/visibility-toggle/visibility-toggle';
import { useIsMobile } from 'src/hooks/useMobile';
import { Button } from 'src/components/ui/button';
import { RefreshCw } from 'lucide-react';
import PacingTable from '../components/pacing-table';
import { useGetPacingDataQuery, useGetPacingViewsQuery } from '../endpoints/pacing.endpoints';
import { AdvertiserNode, UserFilterType, ViewType } from '../types/pacing.types';

const PacingTab: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('table');
  const [activeUserFilter, setActiveUserFilter] = useState<UserFilterType>('all');
  const [selectedPlatform, setSelectedPlatform] = useState<string>('');
  const [selectedView, setSelectedView] = useState<PacingViewApiResponse | undefined>();
  const [showVisibilityToggles, setShowVisibilityToggles] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const isMobile = useIsMobile();

  const [pacingData, setPacingData] = useState<AdvertiserNode[]>([]);
  const { data: views, isLoading: isLoadingViews, error: viewsError, refetch: refetchViews } = useGetPacingViewsQuery();
  const { data: pacingDataRaw, isLoading: isLoadingPacingData, isFetching: isFetchingPacingData, error: pacingDataError } = useGetPacingDataQuery({ 
    viewId: selectedView?.id ?? '',
  }, { skip: !selectedView });

  useEffect(() => {
    if (pacingDataRaw) {
      setPacingData(pacingDataRaw);
    }
  }, [pacingDataRaw]);

  useEffect(() => {
    if (searchQuery && pacingDataRaw) {
      setPacingData(pacingDataRaw.filter((advertiser) => {
        return advertiser?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          advertiser?.source?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          advertiser?.campaigns?.some((campaign) => campaign.name?.toLowerCase().includes(searchQuery.toLowerCase())) ||
          advertiser?.campaigns?.some((campaign) => campaign.line_items.some((lineItem) => lineItem.line_item_name?.toLowerCase().includes(searchQuery.toLowerCase())));
      }));
    } else {
      setPacingData(pacingDataRaw ?? []);
    }
  }, [searchQuery, pacingDataRaw]);

  const handleCreatedView = (view: PacingViewApiResponse) => {
    refetchViews();
    setSelectedView(view);
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}

      <div className="flex justify-between items-center pb-4">
        <div className='flex items-center gap-4 mr-auto'>
        <SearchInput
          placeholder="Search advertisers, campaigns, line items..."
          value={searchQuery}
          onChange={setSearchQuery}
          debounceMs={500}
          className="w-96"
          iconClassName='text-gray-600'
          inputClassName='bg-gray-201 rounded-full placeholder:text-gray-600'
        />
        </div>
        {/* Controls */}
        <div className='flex items-center gap-4 ml-auto'>
          <div className="h-6 border-l border-gray-300" />

          <ViewManager
            savedViews={views ?? []}
            selectedView={selectedView}
            onSelectView={setSelectedView}
          />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden relative">
        {false ? (
          <div className="h-full flex items-center justify-center">
            <div className="text-gray-600">
              Loading pacing data...
            </div>
          </div>
        ) : (
              <PacingTable
                view={selectedView}
                data={pacingData ?? []}
                isLoading={isLoadingPacingData || isFetchingPacingData}
                isUpdating={false}
                isCreated={handleCreatedView}
              />
        )}
      </div>
    </div>
  );
};

export default PacingTab;